import React, { useState } from "react";
import { post } from "../../lib/Fetching";
import CommentInput from "./CommentInput";

export default function CommentPicker({ ids, onApply, clientView }) {
  const [comment, setComment] = useState("");
  const [clientVisible, setClientVisible] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    post("/registration/comments/create_bulk", {
      ids: ids,
      body: comment,
      client_visible: clientVisible,
    })
      .then(() => {
        onApply();
        setComment("");
        setClientVisible(false);
      })
      .catch((e) => {
        console.error("Error creating bulk comments:", e);
        const message = e && e.message ? e.message : "Failed to create comments. Please try again.";
        alert(message);
      });
  };

  const sampleCount = ids && ids.length ? ids.length : 0;
  const sampleIdsText = ids && ids.length ? ids.join(", ") : "None";

  return (
    <div>
      <div style={{ marginBottom: 15 }}>
        <p>
          <strong>{sampleCount} sample(s) selected:</strong> {sampleIdsText}
        </p>
      </div>
      <form onSubmit={handleSubmit} className="form-inline">
        <CommentInput
          comment={comment}
          setComment={setComment}
          clientVisible={clientVisible}
          setClientVisible={setClientVisible}
          clientView={clientView}
        />
      </form>
    </div>
  );
}
